import { useState } from "react";

export const HanldeStates = () => {
    const [dataIsSavedSuccessfully, setDataIsSavedSuccessfully] = useState(false);
    const [imagesSavedSuccessfully, setImagesSavedSuccessfully] = useState(false);
    const [dataIsSubmittedSuccessfully, setDataIsSubmittedSuccessfully] =
      useState(false);
    const [uploading, setUploading] = useState(false);
  
    const [step, setStep] = useState(0);
  
    const [openModal, setOpenModal] = useState(false);
    const [message, setMessage] = useState(null);
    const [viewReport, setViewReport] = useState(false);
    return {
        dataIsSavedSuccessfully,
        setDataIsSavedSuccessfully,
        imagesSavedSuccessfully,
        setImagesSavedSuccessfully,
        dataIsSubmittedSuccessfully,
        setDataIsSubmittedSuccessfully,
        uploading,
        setUploading,
        step,
        setStep,
        openModal,
        setOpenModal,
        message,
        setMessage,
        viewReport,
         setViewReport
    }
}